import { useEffect, useRef } from 'react'
import { useOidcAccessToken, useOidc, OidcClient } from '@axa-fr/react-oidc'
import {
  setAccessTokenOverride,
  setAccessTokenRenewer,
  clearAccessTokenCache
} from '../../actions/tokenBridge'

// The request waiting on this sends straight after, long before the new token
// re-renders through useOidcAccessToken, so hand it to the bridge directly.
const renewAccessToken = async () => {
  const client = OidcClient.get()
  if (!client) return

  await client.renewTokensAsync()

  const renewed = client.tokens?.accessToken
  if (renewed) setAccessTokenOverride(renewed)
}

export default function TokenSync() {
  const { accessToken } = useOidcAccessToken()
  const { isAuthenticated } = useOidc()

  const tok: string | null =
    typeof accessToken === 'string'
      ? accessToken
      : (accessToken as any)?.accessToken || (accessToken as any)?.token || null

  // Sync during render, not in an effect: route components fire API requests
  // from componentDidMount, which runs before passive effects flush. The token
  // must be in the bridge before any of them mount. Idempotent, so safe under
  // StrictMode double-render.
  const lastSynced = useRef<string | null>(null)
  if (tok && tok !== lastSynced.current) {
    lastSynced.current = tok
    setAccessTokenOverride(tok)
  }

  useEffect(() => {
    setAccessTokenRenewer(renewAccessToken)
    return () => setAccessTokenRenewer(null)
  }, [])

  useEffect(() => {
    if (!tok && isAuthenticated === false) {
      lastSynced.current = null
      clearAccessTokenCache()
    }
  }, [tok, isAuthenticated])

  return null
}
